import type { Sessao } from '../api';

/**
 * A folha do "meu código" (tela 2 do mockup): o telefone GRANDE, legível a um
 * braço de distância — é o que a atendente digita no PDV para acumular.
 *
 * ⚠️ O QR do mockup era decorativo. QR de verdade só entra quando o PDV tiver
 * leitor (modo 3 da §14.1); mostrar um código que não escaneia enganaria a
 * atendente na frente do cliente.
 */
export function MeuCodigo({ sessao, fechar }: { sessao: Sessao; fechar: () => void }) {
  return (
    <div className="veu" onClick={fechar}>
      <div className="folha" onClick={(e) => e.stopPropagation()}>
        <div className="folha-pega" />
        <div className="folha-titulo">meu código</div>
        <div className="mc-telefone">{sessao.telefone}</div>
        <div className="mc-sub">fale este número no caixa para acumular</div>
        <button className="botao-vazado" onClick={fechar}>
          Fechar
        </button>
      </div>
    </div>
  );
}
